import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    Typography,
} from '@mui/material';

export const PqrWebChannelDisabledScreen = () => (
    <Dialog
        open
        disableEscapeKeyDown
        scroll="paper"
        fullWidth
        maxWidth="md"
        aria-labelledby="pqr-web-channel-disabled-title"
        aria-describedby="pqr-web-channel-disabled-description"
    >
        <DialogTitle id="pqr-web-channel-disabled-title">
            <Typography
                sx={{
                    fontSize: { lg: 27, xs: 23 },
                    mt: { xs: 1.5, sm: 1.5, md: 1.5, lg: 0 },
                    color: 'primary.main',
                }}
            >
                Canal deshabilitado
            </Typography>
        </DialogTitle>
        <DialogContent dividers>
            <Grid
                container
                item
                xs={12}
                direction="column"
                alignItems="center"
                justifyContent="center"
            >
                <Box
                    style={{
                        maxWidth: '500px',
                        textAlign: 'center',
                        padding: '16px',
                    }}
                >
                    <Typography
                        id="pqr-web-channel-disabled-description"
                        variant="h5"
                    >
                        Este canal está deshabilitado temporalmente, por favor
                        intente más tarde
                    </Typography>
                </Box>
            </Grid>
        </DialogContent>
    </Dialog>
);
